import styled from "styled-components";
import { device } from "../../../utils";

const Wrapper
	= styled.div`
		@media ${device.desktopS} {
			width: 80%;
			margin: 0 auto;
		}
		@media ${device.tabletPDown} {
			width: 100%;
		}

		display: flex;
		overflow-x: auto;

		&::-webkit-scrollbar {
			display: none;
		}
	`

export default Wrapper
